import { UAParser } from 'ua-parser-js';
import type { ARegionName } from '~/features/region/regionService';

export const mailAddress = `support-stepnote@asics.com`;

export const title = {
  ja: `STEPNOTE - ASICS STEPNOTE: お問い合わせ`,
  en: `STEPNOTE - ASICS STEPNOTE: Contact us`,
};

export const text = (asicsId: string | undefined, lang: 'ja' | 'en', region_name: ARegionName) => {
  const parser = new UAParser();
  const browser = parser.getBrowser();
  const device = parser.getDevice();
  const os = parser.getOS();

  /* eslint-disable @typescript-eslint/restrict-template-expressions */
  return lang === 'ja'
    ? `お問い合わせありがとうございます。
以下の項目を記入し送信してください。

お問い合わせの内容や受付状況によりましては、
お答えに日数を要する場合がございます。
何卒、ご理解賜りますようお願い申し上げます。

-----

お名前:
お問い合わせ内容:

-----

以下の情報は削除せず送信ください
デバイス: ${device.vendor} - ${device.model} - ${device.type}
OSバージョン: ${os.name} - ${os.version}
ブラウザ: ${browser.name}
ブラウザバージョン: ${browser.version}
Region: ${region_name}
${asicsId ? `OneASICS ID: ${asicsId}` : ``}
`
    : `Thank you for your email.
Please fill in the following before sending.
Based on the scope of inquiry and the current loading,
the reply can take days.
We thank you for your kind understanding.
-----

Name:
Content of inquiry:

-----

Please do not delete the following info; just submit and send the email!
Device: ${device.vendor} - ${device.model} - ${device.type}
OS version: ${os.name} - ${os.version}
Browser: ${browser.name}
Browser version: ${browser.version}
Region: ${region_name}
${asicsId ? `OneASICS ID：${asicsId}` : ``}
`;
};
